module.exports = __webpack_public_path__ + "static/img/ll.fed9a762.jpg";